import { getSectionRequiredCapabilities } from '@emporion/config/sections'
import { hasAnyCapability } from '../../utils/permissions'

const CUSTOMER_PORTAL_CAPABILITY = 'customer_portal_access'

export const hasBackofficeCapabilities = (capabilities: readonly string[]): boolean =>
  capabilities.includes('*') || capabilities.some((capability) => capability !== CUSTOMER_PORTAL_CAPABILITY)

export const isCustomerOnlyCapabilities = (capabilities: readonly string[]): boolean =>
  capabilities.includes(CUSTOMER_PORTAL_CAPABILITY) && !hasBackofficeCapabilities(capabilities)

export const canBootstrapSectionResource = (
  sectionKey: string,
  capabilities: readonly string[],
): boolean => hasAnyCapability([...capabilities], getSectionRequiredCapabilities(sectionKey))
